export default __webpack_public_path__ + "static/media/micrp.047c9c05.png";